import { ResponsiveProp } from "../../utils/responsiveProps";

// TODO: update this to handle negative dimensions
export type Dimension =
  | "auto"
  | "none"
  | "xxxsmall"
  | "xxsmall"
  | "xsmall"
  | "small"
  | "medium"
  | "large"
  | "12"
  | "xlarge"
  | "24"
  | "xxlarge"
  | "xxxlarge";

export const DIMENSIONS: { [key in Exclude<Dimension, "auto">]: number } = {
  none: 0,
  xxxsmall: 1,
  xxsmall: 2,
  xsmall: 3,
  small: 4,
  medium: 6,
  large: 8,
  "12": 12,
  xlarge: 16,
  "24": 24,
  xxlarge: 32,
  xxxlarge: 48
};

export const dimensionsArray = Object.keys(DIMENSIONS) as Dimension[];

export type ResponsiveDimension = ResponsiveProp<Dimension | null>;

export const DEFAULT_DIMENSION: Dimension = "small";

export function validateDimension(dimension: Dimension) {
  if (!dimensionsArray.includes(dimension)) {
    throw new Error(`Invalid dimension '${dimension}' received.

Should be one of: 
\t * ${dimensionsArray.join("\n\t * ")}`);
  }
}

export function getDimension(dimension?: Dimension | null) {
  if (!dimension) {
    return undefined;
  }

  if (dimension === "auto") return dimension;

  const dimensionIsNegative = dimension.startsWith("-");

  const _dimension = dimensionIsNegative
    ? (dimension.slice(1) as Exclude<Dimension, "auto">)
    : dimension;

  validateDimension(_dimension);

  const value = DIMENSIONS[_dimension];
  return dimensionIsNegative ? -1 * value : value;
}

export function makeDimensionNegative(layoutDimension?: ResponsiveDimension) {
  if (!layoutDimension) {
    return layoutDimension;
  }

  if (typeof layoutDimension === "string") {
    return `-${layoutDimension}` as ResponsiveDimension;
  }

  return (layoutDimension as Dimension[]).map(
    dim => `-${dim}`
  ) as ResponsiveDimension;
}

export function getDimensionPx(dimension?: Dimension | null) {
  const _dim = getDimension(dimension);

  if (_dim === undefined) return undefined;
  if (_dim === "auto") return _dim;

  return isNaN(_dim) ? undefined : `${_dim}px`;
}

export function mapResponsiveDimensionsToPx(
  layoutDimension?: ResponsiveDimension
): ResponsiveProp<string> | undefined {
  if (!layoutDimension) {
    return undefined;
  }

  if (layoutDimension === "auto") return layoutDimension;

  if (
    typeof layoutDimension === "string" ||
    typeof layoutDimension === "number"
  ) {
    return getDimensionPx(layoutDimension);
  }

  return layoutDimension.map(getDimensionPx) as ResponsiveProp<string>;
}

export function pxToRem(size: number) {
  return `${size / 16}rem`;
}
